<mat-form-field appearance="outline" color="primary" class="input">
  <mat-label>{{label}}</mat-label>
  <input matInput focused="true" placeholder="{{placeholder}}" (click)="fileInput.click()"
         value="{{fileName}}">
  <input hidden type="file" #fileInput (change)="onInput($event)">
  <mat-hint>{{hint}}</mat-hint>
</mat-form-field>
